<template>
  <div class="flex flex-wrap gap-2 pt-2">
    <button
      v-for="tag in tags"
      :key="tag"
      class="rounded-[2px] border-[0.5px] border-light-bd-muted bg-light-bg-default px-4 py-2 font-Spectral text-base text-light-fg-accent transition-colors hover:border-light-bd-accent hover:bg-light-bg-inset focus:border-light-bd-accent focus:bg-light-bg-inset disabled:cursor-not-allowed disabled:opacity-50"
      type="button"
      :disabled="disabled"
      @click="$emit('select', tag)"
    >
      {{ tag }}
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  tags: string[];
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

defineEmits<{
  select: [tag: string];
}>();
</script>
